// import VueRouter from "vue-router";
import router from './router'
import store from './store'

// import {  MessageBox } from 'element-ui'
//import NProgress from 'nprogress' // 进度条
//import 'nprogress/nprogress.css' // 进度条样式
import {
	getToken
} from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
// import { asyncRoutes } from './router'
// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/index', '/about', '/news', '/product', '/honor', '/party', '/about', '/culture',
	'/search'
] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
	// start progress bar

	// NProgress.start()

	// set page title
	// document.title = getPageTitle(to.meta.title)
	// determine whether the user has logged in
	const hasToken = getToken()
	if (hasToken) {
		if (to.path === '/login') {
			// if is logged in, redirect to the home page
			next({
				path: '/index'
			})
			// NProgress.done()
		} else {
			const hasGetUserInfo = store.state.name

			if (hasGetUserInfo) {
				next()
			} else {
				try {
					// get user info
					await store.dispatch('getInfo')
					// if(to.path == '/article_list4'){
					//   if(store.state.info.userLevel == 2){
					//     next()
					//   }else{
					//     MessageBox('暂无访问权限，请联系管理员！','提示')
					//   }
					// }
					next()
				} catch (error) {
					// remove token and go to login page to re-login
					await store.dispatch('resetToken')
					// Message.error(error || 'Has Error')
					next(`/index`)
					// NProgress.done()
				}
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			// next(`/login?redirect=${to.path}`)
			next()
			// next('/index')
			// NProgress.done()
		}
	}
})

router.afterEach(() => {
	// finish progress bar
	// NProgress.done()
})
